<nz-anchor [nzTargetOffset]="offset">
  <nz-link
    *ngFor="let item of anchorItems"
    nzHref="#{{ item.code }}"
    nzTitle="{{ item.label }}"
  >
    <ng-container *ngFor="let child of item.children">
      <nz-link nzHref="#{{ child.code }}" nzTitle="{{ child.label }}"></nz-link>
    </ng-container>
  </nz-link>
</nz-anchor>
